import { ThemeEvents } from '@theme/events';

/**
 * VariantInfo
 * Re-renders variant metafield content when the variant changes.
 * Uses Horizon's server-rendered HTML (same pipeline as price).
 */
class VariantInfo extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateVariantInfo
    );
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateVariantInfo
    );
  }

  updateVariantInfo = (event) => {
    // Guard: wrong product
    if (
      event.detail.data.newProduct &&
      event.detail.data.newProduct.id !== this.dataset.productId
    ) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    // Find updated block in server-rendered HTML
    const newBlock =
      event.detail.data.html.querySelector(
        `variant-info[data-block-id="${this.dataset.blockId}"]`
      );

    if (!newBlock) {
      // Block no longer exists for this variant → remove
      this.remove();
      return;
    }

    // Replace entire block (safe, identical to price behavior)
    this.replaceWith(newBlock);
  };
}

if (!customElements.get('variant-info')) {
  customElements.define('variant-info', VariantInfo);
}
